import CompanyTable from './CompanyTable';

export default CompanyTable;
